import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';
import {
  IEgaugeRegister,
  ICreateAutoRegister,
} from '@/Core.Service.Domain/Monitors/Egauges/types/register';

import { IUnmappedRegisters } from '@/Core.Service.Domain/Monitors/Egauges/types/unmappedRegisters.ts';

import { IEgauge } from '@/Core.Service.Domain/Monitors/Egauges/types/egauge.ts';

const getSites = async (): Promise<ISite[]> => {
  try {
    const result = await window.axios.get('/v1/sites/portfolio');
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getRegistriesByEgaugeId = async (
  eGaugeId: string | number
): Promise<IEgaugeRegister[]> => {
  try {
    const result = await window.axios.get(
      `/v1/EgaugeRegister/monitor/${eGaugeId}`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getEgaugeById = async (egaugeId: string | number): Promise<IEgauge> => {
  try {
    const result = await window.axios.get(
      `/v1/EgaugeMonitor/egauge/${egaugeId}`
    );
    const { data } = result.data;
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getEgaugesForSite = async (siteId: string | number) => {
  try {
    const result = await window.axios.get(`/v1/EgaugeMonitor/site/${siteId}`);
    const { data } = result.data;
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getSiteLocationsBySiteId = async (siteId: string | number) => {
  try {
    const result = await window.axios.get(
      `/v1/sitelocation/SiteLocations/${siteId}`
    );
    const { data } = result.data;
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getUnmappedRegistersByEgaugeId = async (
  eGaugeId: string | number
): Promise<Partial<IEgaugeRegister[] | IUnmappedRegisters | []>> => {
  try {
    const result = await window.axios.get(
      `/v1/egaugemonitors/${eGaugeId}/unmapped-registers`
    );
    if (result && result.data) {
      const { data } = result.data;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    if ((err as { status?: number }).status === 404) {
      return [];
    }
    return Promise.reject(err);
  }
};

const updateUnmappedRegisters = async (
  eGaugeId: string | number,
  unmappedRegisters: ICreateAutoRegister[]
) => {
  try {
    await window.axios.post(
      `v1/egaugemonitors/${eGaugeId}/autoregistration`,
      unmappedRegisters
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getSites,
  getRegistriesByEgaugeId,
  getEgaugeById,
  getEgaugesForSite,
  getSiteLocationsBySiteId,
  getUnmappedRegistersByEgaugeId,
  updateUnmappedRegisters,
};
